"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductStatus = void 0;
var EProductStatus;
(function (EProductStatus) {
    EProductStatus["ACTIVE"] = "active";
    EProductStatus["INACTIVE"] = "inactive";
    EProductStatus["ENABLED"] = "enabled";
    EProductStatus["DISABLED"] = "disabled";
})(EProductStatus || (exports.EProductStatus = EProductStatus = {}));
